module.exports = __webpack_public_path__ + "img/docsSheetsSlides.4a821134.png";